// Lógica específica para analizar productos y precios en cotizaciones

export const createSalesFragments = (pageText, pageNumber) => {
  const fragments = [];

  // Detectar productos/precios
  const productMatches = [...pageText.matchAll(/(?:producto|servicio|artículo|ítem)[\s:]+([^\n]+)[\s\n]+(?:precio|valor|costo|monto)[\s:]+([^\n]+)/gi)];
  productMatches.forEach(match => {
    fragments.push({
      text: match[0],
      pageNumber,
      structureType: 'product',
      structureHeader: match[1].trim(),
      product_category: categorizeProduct(match[1]),
      price_range: extractPriceRange(match[2]),
      product_name: match[1].trim(),
      price_value: extractNumericPrice(match[2])
    });
  });

  // Detectar secciones de cotización
  const sectionMatches = [...pageText.matchAll(/(?:sección|apartado|parte)[\s:]+([^\n]+)/gi)];
  sectionMatches.forEach(match => {
    fragments.push({
      text: match[0],
      pageNumber,
      structureType: 'section',
      structureHeader: match[1].trim(),
      section_type: categorizeSection(match[1])
    });
  });

  // Fragmentos de contenido general
  const contentFragments = createContentFragments(pageText, pageNumber, 200);
  fragments.push(...contentFragments);

  return fragments;
};

export const categorizeProduct = (productName) => {
  const categories = {
    software: /software|sistema|aplicación|plataforma|app/i,
    hardware: /hardware|equipo|dispositivo|máquina|impresora|computadora/i,
    servicio: /servicio|consultoría|asesoría|capacitación|instalación/i,
    producto: /producto|artículo|ítem|material/i,
    licencia: /licencia|suscripción|subscripción/i,
    mantenimiento: /mantenimiento|soporte|técnico/i
  };
  for (const [cat, regex] of Object.entries(categories)) {
    if (regex.test(productName)) return cat;
  }
  return 'general';
};

export const extractPriceRange = (priceText) => {
  const price = extractNumericPrice(priceText);
  if (!price) return null;

  if (price < 100) return 'bajo';
  if (price < 1000) return 'medio';
  if (price < 10000) return 'alto';
  return 'premium';
};

export const extractNumericPrice = (priceText) => {
  const priceMatch = priceText.match(/[\d,]+\.?\d*/);
  if (priceMatch) {
    return parseFloat(priceMatch[0].replace(/,/g, ''));
  }
  return null;
};

export const categorizeSection = (sectionName) => {
  const sections = {
    introduccion: /introducción|presentación|resumen/i,
    productos: /productos|servicios|ítems|catálogo/i,
    precios: /precios|costos|cotización|presupuesto/i,
    condiciones: /condiciones|términos|pago|entrega/i,
    especificaciones: /especificaciones|técnicas|detalles/i
  };
  for (const [sec, regex] of Object.entries(sections)) {
    if (regex.test(sectionName)) return sec;
  }
  return 'general';
};

export const createContentFragments = (pageText, pageNumber, chunkSize = 200) => {
  const cleanText = pageText.replace(/\s+/g, ' ').trim();
  if (!cleanText) return [];

  const chunks = [];
  let start = 0;
  while (start < cleanText.length) {
    let end = Math.min(start + chunkSize, cleanText.length);
    if (end < cleanText.length) {
      const lastSpace = cleanText.lastIndexOf(' ', end);
      if (lastSpace > start) end = lastSpace + 1;
    }
    chunks.push(cleanText.substring(start, end).trim());
    start = end;
  }

  return chunks.map((chunk, index) => ({
    text: chunk,
    pageNumber,
    structureType: null,
    structureHeader: null,
    isContentFragment: true,
    chunkIndex: index + 1
  }));
};